import * as React from 'react'
import { useCallback } from 'react'
import { ButtonCompleted } from '../atoms'

type Props = {
  orderUrl: string
  appointmentId: string
}

export function ManageButton(props: Props) {
  const { orderUrl, appointmentId } = props

  const onClick = useCallback(() => window.open(orderUrl, '_blank'), [orderUrl])

  return (
    <ButtonCompleted
      color="primary"
      variant="contained"
      onClick={onClick}
      data-test-id={`manage-in-pestpac-button-${appointmentId}`}
    >
      Manage in PestPac
    </ButtonCompleted>
  )
}
